// extracted by mini-css-extract-plugin
module.exports = {"component":"header_component__pvi4q","isFixed":"header_isFixed__160ym","isHidden":"header_isHidden__2ZpJs"};